<template>
  <div id="app-shell">
    <SitePasswordGate v-if="!isUnlocked" @unlocked="handleUnlocked" />
    <router-view v-else />
  </div>
</template>

<script>
import SitePasswordGate from './components/SitePasswordGate.vue'
import { isSiteUnlocked } from './utils/siteAuth'

export default {
  name: 'App',
  components: {
    SitePasswordGate,
  },
  data() {
    return {
      isUnlocked: false,
    }
  },
  created() {
    this.isUnlocked = isSiteUnlocked()
  },
  mounted() {
    this.syncBodyScroll()
  },
  watch: {
    isUnlocked() {
      this.syncBodyScroll()
    },
  },
  beforeUnmount() {
    document.body.style.overflow = ''
  },
  methods: {
    handleUnlocked() {
      this.isUnlocked = true
    },
    syncBodyScroll() {
      document.body.style.overflow = this.isUnlocked ? '' : 'hidden'
    },
  },
}
</script>

<style>
#app {
  width: 100%;
  margin: 0;
  padding: 0;
  overflow-x: hidden;
}

body {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  background: linear-gradient(187deg, rgb(238 242 249) 0%, rgb(255 255 255 / 8%) 50%, rgb(99 123 186 / 8%) 100%);
}

html.dark body {
  background: #181818;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

html.dark {
  color-scheme: dark;
}

/* 滚动条样式 */
::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.3);
}

html.dark ::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.15);
}

html.dark ::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.25);
}
</style>
